import {
	EventBus
} from '@/support/event-bus';

export default {
	name: 'create-homework-button',
	methods: {
		toggleHomework() {

			EventBus.$emit('toggleHomework');

		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/homework/create/index.js